import {useContext} from 'react';

import {Route, Routes} from 'react-router-dom';

import {AppHeader} from '../components/AppHeaders/AppHeader';
import {ErrorMessage} from '../components/ErrorMessage/ErrorMessage';
import {PageContainer} from '../components/PageContainer/PageContainer';
import {CompanyProvider} from '../contexts/CompanyContext/CompanyProvider';
import {UserContext} from '../contexts/UserContext/UserContext';
import {AccountSettings} from '../pages/user/account/Settings/AccountSettings';
import {VerifyPage} from '../pages/user/account/VerifyPage/VerifyPage';
import {ConfirmAccountPage} from '../pages/user/registration/ConfirmAccountPage';

export const UserAccountRoutes = () => {
  const {isRoleCompany} = useContext(UserContext);

  if (isRoleCompany) {
    return (
      <>
        <CompanyProvider>
          <PageContainer>
            <AppHeader type='company' />
            <Routes>
              <Route path='/*'>
                <Route path='verify' element={<VerifyPage />} />
                <Route path='settings' element={<AccountSettings />} />
                <Route path='confirm-account' element={<ConfirmAccountPage />} />
                <Route path='*' element={<ErrorMessage isOutOfBounds />} />
              </Route>
            </Routes>
          </PageContainer>
        </CompanyProvider>
      </>
    );
  }
  return (
    <>
      <PageContainer>
        <AppHeader type='applicant' />
        <Routes>
          <Route path='/*'>
            <Route path='verify' element={<VerifyPage />} />
            <Route path='settings' element={<AccountSettings />} />
            <Route path='confirm-account' element={<ConfirmAccountPage />} />
            <Route path='*' element={<ErrorMessage isOutOfBounds />} />
          </Route>
        </Routes>
      </PageContainer>
    </>
  );
};
